// extracted by mini-css-extract-plugin
export default {"content":"MainContent_content__5yU6I","isMobile":"MainContent_isMobile__qELNV","landing-view":"MainContent_landing-view__Cbfjf"};